import ArkLoader from '@src/js/common/ark-extensions';
import componentConfig from './component-config';
import i18n from '@i18next/i18n';
import { openPay } from '../pay';
import { getAidForReport } from '@tencent/txdocs-aid';
import { tdw, ITdwOptions } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

interface LinkTextProps {
    ref: HTMLDivElement|null;
    name: string;
    position: string;
    feature: string;
    apprec: string;
    anchor?: string;
}

interface VipLinkExtensionProps {
    title: string;
    btnText: string;
    container: HTMLDivElement|null;
    titleBackgroundType: string;
    btnStyle?: React.CSSProperties|undefined;
    titleStyle: React.CSSProperties|undefined;
    iconStyle: React.CSSProperties|undefined;
    onClickTitle: undefined | (() => any),
    onClickBtn: undefined | (() => any),
    onClickIcon: undefined | (() => any),
}

enum VipInfo {
    SVIP_PLUS = 'svip_plus',
    SVIP = 'svip_user',
    VIP = 'vip_user',
    NOVIP = 'novip_user'
}

export const LINK_TEXT = 'linktext';

export function isVip() {
    const vipInfo = ArkLoader.extensionService.dependentServiceCombinder?.accountApplication?.vipInfo;
    return vipInfo?.vip?.status === 2;
}

export function isSVip() {
    const vipInfo = ArkLoader.extensionService.dependentServiceCombinder?.accountApplication?.vipInfo;
    return vipInfo?.svip?.status === 2;
}

export function isSVipPlus() {
    const vipInfo = ArkLoader.extensionService.dependentServiceCombinder?.accountApplication?.vipInfo;
    return vipInfo?.svipPlus?.status === 2;
}

export function getVipInfo(): VipInfo {
    const vipInfo = ArkLoader.extensionService.dependentServiceCombinder?.accountApplication?.vipInfo;
    if (vipInfo?.svipPlus?.status === 2) {
        return VipInfo.SVIP_PLUS;
    }
    if (vipInfo?.svip?.status === 2) {
        return VipInfo.SVIP;
    }
    if (vipInfo?.vip?.status === 2) {
        return VipInfo.VIP;
    }
    return VipInfo.NOVIP;
}

export async function isVipByFetch() {
    await ArkLoader.extensionService.dependentServiceCombinder?.accountApplication.updateVipInfo();
    return isVip();
}

export function onVipLinkClick(aid: string, reportParams: any, clickPosition: string, anchor?: string) {
    const reportParam = { ...reportParams };
    reportParam.action = TDWActionType.COMBINATION_CLICK;
    reportParam.eventcode = `${TDWOperationType.VIP_UPGRADE}-${TDWModuleType.LINK_TEXT}-${TDWActionType.COMBINATION_CLICK}`;
    reportParam.ver10 = clickPosition;
    tdw(reportParam);
    openPay(aid, anchor);
}

export async function showVipLinktext(props: LinkTextProps): Promise<void> {
    const { ref, name, position, feature, apprec, anchor } = props;

    const isvip = isVip();
    const title = isvip ? i18n.t('正在享受{0}会员特权', { 0: name }) : i18n.t('会员专享{0}特权', { 0: name });
    const extension = await ArkLoader.extensionService.getExtension(componentConfig.name);
    const apprec2 = apprec === LINK_TEXT ? undefined : LINK_TEXT;
    const aid = getAidForReport({
        feature,
        position,
        apprec1: apprec,
        apprec2,
    });
    const reportParams = {
        opername: TDWOperationType.VIP_UPGRADE,
        module: TDWModuleType.LINK_TEXT,
        action: TDWActionType.SHOW,
        eventcode: `${TDWOperationType.VIP_UPGRADE}-${TDWModuleType.LINK_TEXT}-${TDWActionType.SHOW}`,
        ver5: getVipInfo(),
        ver6: feature,
        ver7: apprec,
        ver8: aid,
        ver9: `pc_${position}`,
    };
    const showParams: VipLinkExtensionProps = {
        title,
        btnText: i18n.t('开通会员'),
        container: ref,
        titleBackgroundType: 'golden',
        titleStyle: { cursor: 'pointer' },
        iconStyle: { cursor: 'pointer' },
        onClickTitle: () => onVipLinkClick(aid, reportParams, 'text', anchor),
        onClickBtn: () => onVipLinkClick(aid, reportParams, 'upgrade'),
        onClickIcon: () => onVipLinkClick(aid, reportParams, 'icon', anchor),
    };
    if (isvip) {
        showParams.btnText = '';
        showParams.titleBackgroundType = 'gray';
        showParams.btnStyle = { display: 'none' };
        showParams.titleStyle = undefined;
        showParams.iconStyle = undefined;
    }
    extension.show(showParams);
    tdw(reportParams);
}

/**
 * 携带用户身份上报，用户身份使用ver5字段
 */
export function tdwWithVip(options: ITdwOptions = {}): void {
    tdw({ ...options, ver5: getVipInfo() });
}
